import { Dashboard, OffplanAdmin } from '@/components';

export const OffplanAdminPage = () => (
  <Dashboard>
    <OffplanAdmin />
  </Dashboard>
);
